import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from '@buoyhealth/common.buoy-button';
import Grid from '@mui/material/Grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { Checkbox } from '@buoyhealth/common.buoy-input';
import useParentTransition from '../hooks/useParentTransition';
import useTermsAgreed from '../hooks/useTermsAgreed';
import useInterviewType from '../hooks/useInterviewType';
import { getCategory } from '../analytics';
import useInterview from '../hooks/useInterview';
import { trackStructuredEvent } from 'src/analytics';

const StyledLink = styled(Link)`
  font-size: 14px;
`;

const TermsAndConditions = ({ questionIndex }: { questionIndex?: number }) => {
  const globalTermsAgreed = useTermsAgreed();
  const interviewType = useInterviewType();
  const interview = useInterview();
  const parentTransition = useParentTransition();

  const [termsAgreed] = useState(globalTermsAgreed);

  const onAgreeClick = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    trackStructuredEvent({
      category: getCategory(interviewType),
      action: 'terms-agreed',
      label: interview.token || '',
      value: checked ? 1 : 0,
    });

    parentTransition({
      event: 'TERMS_AGREED',
      data: { termsAgreed: checked },
    });
  };

  if (termsAgreed) {
    return null;
  }

  return (
    <Grid item sx={{ paddingLeft: 1.5, fontSize: '14px' }} className="TermsAndConditions">
      <FormControlLabel
        className="bp-flex bp-items-start"
        control={
          <Checkbox className="bp-mt-[-6px]" checked={globalTermsAgreed} onChange={onAgreeClick} />
        }
        label={
          <div className="bp-ml-1 bp-flex bp-min-h-[26px] bp-items-center">
            <Typography variant="body2">
              {'By checking this box, you attest that you are at least 13-years-old and agree to'}{' '}
              Buoy&apos;s{' '}
              <StyledLink href="/terms" target="_blank">
                Terms of Use
              </StyledLink>{' '}
              and{' '}
              <StyledLink href="/privacy" target="_blank">
                Privacy Policy
              </StyledLink>
              {'.'}
            </Typography>
          </div>
        }
      />
    </Grid>
  );
};

export default TermsAndConditions;
